import { useTranslation } from "react-i18next";
import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { fillLegalDate } from "../../../utils/legalDate";
import LegalVersionNote from "../../legal/LegalVersionNote";

const SectionTitle = ({ children }) => (
    <Text
        fontWeight={700}
        fontSize={'18px'}
        lineHeight={'28px'}
        color={'#1E1517'}
        mt={'8px'}
    >
        {children}
    </Text>
);

const SectionParagraph = ({ children }) => (
    <Text
        fontWeight={400}
        fontSize={'15px'}
        lineHeight={'26px'}
        color={'#3B3033'}
    >
        {children}
    </Text>
);

const Regulations = () => {
    const { t } = useTranslation("regulations");

    const sections = [
        {
            title: 's1.title',
            paragraphs: ['s1.p1', 's1.p2', 's1.p3', 's1.p4', 's1.p5', 's1.p6'],
        },
        {
            title: 's2.title',
            paragraphs: ['s2.p1', 's2.p2', 's2.p3', 's2.p4', 's2.p5', 's2.p6', 's2.p7', 's2.p8'],
        },
        {
            title: 's3.title',
            paragraphs: ['s3.p1', 's3.p2'],
        },
        {
            title: 's4.title',
            paragraphs: ['s4.p1', 's4.p2', 's4.p3'],
        },
        {
            title: 's5.title',
            paragraphs: ['s5.p1', 's5.p1a', 's5.p1b', 's5.p1c', 's5.p1d', 's5.p1e', 's5.p1f', 's5.p2'],
        },
        {
            title: 's6.title',
            paragraphs: ['s6.p1', 's6.p2', 's6.p3'],
        },
        {
            title: 's7.title',
            paragraphs: ['s7.p1', 's7.p2', 's7.p3', 's7.p4', 's7.p5'],
        },
        {
            title: 's8.title',
            paragraphs: ['s8.p1', 's8.p2', 's8.p3', 's8.p4', 's8.p5'],
        },
        {
            title: 's9.title',
            paragraphs: ['s9.p1', 's9.p2', 's9.p3'],
        },
        {
            title: 's10.title',
            paragraphs: ['s10.p1', 's10.p2', 's10.p3', 's10.p4', 's10.p5'],
        },
        {
            title: 's11.title',
            paragraphs: ['s11.p1', 's11.p2', 's11.p2a', 's11.p2b', 's11.p2c', 's11.p3', 's11.p4'],
        },
        {
            title: 's12.title',
            paragraphs: ['s12.p1', 's12.p2', 's12.p3'],
        },
        {
            title: 's13.title',
            paragraphs: ['s13.p1', 's13.p2', 's13.p3', 's13.p4'],
        },
        {
            title: 's14.title',
            paragraphs: ['s14.p1', 's14.p2', 's14.p3'],
        },
        {
            title: 's15.title',
            paragraphs: ['s15.p1', 's15.p2', 's15.p3', 's15.p4'],
        },
        {
            title: 's16.title',
            paragraphs: ['s16.p1', 's16.p2', 's16.p3', 's16.p4'],
        },
        {
            title: 's17.title',
            paragraphs: ['s17.p1', 's17.p2', 's17.p3'],
        },
        {
            title: 's18.title',
            paragraphs: ['s18.p1', 's18.p2', 's18.p3', 's18.p4'],
        },
        {
            title: 's19.title',
            paragraphs: ['s19.p1', 's19.p2'],
        },
        {
            title: 's20.title',
            paragraphs: ['s20.p1', 's20.p1a', 's20.p1b', 's20.p1c', 's20.p2', 's20.p3'],
        },
        {
            title: 's21.title',
            paragraphs: ['s21.p1', 's21.p2'],
        },
        {
            title: 's22.title',
            paragraphs: ['s22.p1', 's22.p2', 's22.p3'],
        },
        {
            title: 's23.title',
            paragraphs: ['s23.p1', 's23.p2', 's23.p3'],
        },
    ];

    return (
        <>
            <Box w={'full'} fontFamily="body">
                <Container maxW={'7xl'} py={'64px'}>
                    <Flex flexDirection={'column'} gap={'8px'}>

                        {/* Nagłówek strony */}
                        <Text
                            fontWeight={700}
                            fontSize={'26px'}
                            lineHeight={'38px'}
                            color={'#1E1517'}
                            textAlign={'center'}
                            mb={'4px'}
                        >
                            {t('page_title')}
                        </Text>

                        {/* Metadane */}
                        <Flex gap={'16px'} flexDirection={{ base: 'column', sm: 'row' }} mb={'32px'}>
                            <Text fontWeight={400} fontSize={'13px'} color={'#6E6064'}>
                                {fillLegalDate(t('effective_date'))}
                            </Text>
                            <Text fontWeight={400} fontSize={'13px'} color={'#6E6064'}>
                                {fillLegalDate(t('version'))}
                            </Text>
                        </Flex>

                        <LegalVersionNote doc="regulations" />
                        {/* Separator */}
                        <Flex w={'full'} h={'1px'} bg={'#ECE4E4'} mb={'32px'} />

                        {/* Sekcje §1–§23 */}
                        <Flex gap={'32px'} flexDirection={'column'} w={'full'}>
                            {sections.map((section) => (
                                <Flex key={section.title} flexDirection={'column'} gap={'12px'}>
                                    <SectionTitle>
                                        {t(section.title)}
                                    </SectionTitle>
                                    {section.paragraphs.map((pKey) => (
                                        <SectionParagraph key={pKey}>
                                            {t(pKey)}
                                        </SectionParagraph>
                                    ))}
                                </Flex>
                            ))}
                        </Flex>

                    </Flex>
                </Container>
            </Box>
        </>
    );
};

export default Regulations;

